<template>
  <el-dialog :visible="show" @close="closeModal">
    <div class="title_popup text-center">Thêm người dùng</div>
    <el-form
      label-width="150px"
      :model="createUserForm"
      label-position="left"
      :rules="rules"
      :hide-required-asterisk="true"
      ref="createUserForm"
      @keyup.enter.native="handleCreateUserSubmit"
    >
      <div v-if="errorMessage" class="error-message">{{ errorMessage }}</div>
      <el-form-item label="Họ tên" prop="name">
        <el-input v-model="createUserForm.name" placeholder="Họ tên "></el-input>
      </el-form-item>
      <el-form-item label="Email" prop="email">
        <el-input v-model="createUserForm.email" placeholder="Email"></el-input>
      </el-form-item>

      <el-form-item label="Ngày hết hạn" prop="expireTime">
        <el-date-picker
          style="width: 100%"
          v-model.number="createUserForm.expireTime"
          type="datetime"
          format="dd/MM/yyyy"
          value-format="timestamp"
          placeholder="Chọn thời gian"
        >
        </el-date-picker>
      </el-form-item>
      <el-form-item label="Mật khẩu">
        <div style="text-align: left">
          <el-radio v-model="defaultPasswordType" :label="false" border>Mật khẩu ngẫu nhiên</el-radio>
          <el-radio v-model="defaultPasswordType" :label="true" border>Mật khẩu mặc định</el-radio>
        </div>
      </el-form-item>
      <el-form-item label="Mật khẩu mặc định" v-if="defaultPasswordType" prop="defaultPassword">
        <el-input v-model="createUserForm.defaultPassword" type="password"></el-input>
      </el-form-item>

      <el-form-item label="Vai trò" prop="roles">
        <el-select v-model="createUserForm.pricingPlanId" placeholder="Chọn" style="width: 100%">
          <el-option v-for="item in pricingPlans" :key="item.id" :label="item.name" :value="item.id" />
        </el-select>
      </el-form-item>
    </el-form>

    <span slot="footer" class="dialog-footer">
      <el-button @click="closeModal">Trở về</el-button>
      <CommonButton :ref="refs.SUBMIT_BUTTON" type="primary" @click="handleCreateUserSubmit"
        >Tạo người dùng</CommonButton
      >
    </span>
  </el-dialog>
</template>

<script>
import { createUser } from '@/services/user_service.js'
import { apiGetAllPricingPlan } from '@/services/pricing_plan_service.js'
import CommonButton from '@/components/common/CommonButton.vue'

export default {
  name: 'CreateSingleUserModal',
  components: { CommonButton },
  data: function () {
    return {
      createUserForm: {
        defaultPassword: null,
        email: null,
        expireTime: new Date().getTime() + 30 * 24 * 3600 * 1000,
        name: null,
        pricingPlanId: null,
      },
      defaultPasswordType: false,
      rules: {
        name: [{ required: true, message: 'Nhập tên đăng ký' }],
        email: [
          { required: true, message: 'Hãy nhập email', trigger: 'change' },
          { type: 'email', message: 'Hãy nhập chính xác địa chỉ email', trigger: 'blur' },
        ],
        defaultPassword: [{ min: 8, message: 'Mật khẩu tối thiểu 8 kí tự' }],
        maxDocument: [{ required: true, message: 'Hãy nhập số tài liệu tối đa', trigger: 'change' }],
        pricingPlan: [{ required: true, message: 'Hãy chọn loại tài khoản', trigger: 'change' }],
        expireTime: [{ required: true, message: 'Nhập ngày hết hạn', trigger: 'change' }],
      },
      errorMessage: null,
      show: false,
      pricingPlans: [],
      refs: {
        SUBMIT_BUTTON: 'submitButton',
      },
    }
  },
  async mounted() {
    this.pricingPlans = (await apiGetAllPricingPlan()).data
    this.createUserForm.pricingPlan = this.pricingPlans[0].id
  },
  methods: {
    showModal() {
      this.show = true
    },
    closeModal() {
      this.show = false
    },
    handleCreateUserSubmit: async function () {
      this.errorMessage = null
      this.$refs['createUserForm'].validate(async (valid) => {
        if (!valid) return false

        this.$refs[this.refs.SUBMIT_BUTTON].setLoading(true)
        try {
          let response = await createUser(this.createUserForm)
          if (response) {
            this.$message.success('Tạo người dùng thành công')
            this.show = false
            this.$emit('success')
          }
        } catch (e) {
          this.$message.error(e.response.data.description)
        }
        this.$refs[this.refs.SUBMIT_BUTTON].setLoading(false)
      })
    },
  },
}
</script>
